import { HttpInterceptorFn } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { inject } from '@angular/core';
import { HttpLoadingProgressService } from '../services/http-loading-progress-service/http-loading-progress.service';

// This interceptor tracks the loading progress of HTTP GET requests
export const loadingProgressInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingProgressService = inject(HttpLoadingProgressService);

  // Check if the request is a GET request
  if (req.method.toUpperCase() !== 'GET') {
    return next(req);
  }

  // Start loading
  loadingProgressService.startLoading();

  return next(req).pipe(
    finalize(() => {
      // Stop loading when request completes (success or error)
      loadingProgressService.stopLoading();
    }),
  );
};
